

import './style.css';
import logo from './images/logo.svg';
import chartData from './data.json';

function App() {
  return (
    <>
      <main>
        <Balance />
        <Expense data={chartData} />
      </main>
    </>
  );
}

function Balance() {
  return (
    <>
      <div className="balance-component">
        <div className="balance-info">
          <div>
            <div className="balance-header">My balance</div>
            <div className="balance-value">$921.48</div>
          </div>
          <div> <img src={logo} alt="" /> </div>
        </div>
      </div>
    </>
  );
}

function Expense(props) {
  //console.log(Array.isArray(props.data));
  let maxValue = 0;
  props.data.map((item) => {
    if (maxValue < item.amount) {
      maxValue = item.amount;
    }
  });

  console.log(maxValue);

  return (
    <>
      <div className="expense-component">
        <div className="expense-info">
          <h1>Spending - Last 7 days</h1>
          <div className="expense-chart">
            {props.data.map((item) => {

              return (
                <div className="chart-column" key={item.day}>
                  <div className="chart-amount">
                    <div style={{ padding: 5 }}>${item.amount}</div>
                  </div>
                  <div className={item.amount === maxValue ? "chart-bar chart-bar-bc-max" : "chart-bar"}
                    style={{ height: (item.amount * 85 / maxValue)+"%" }}></div>
                  <div className="chart-header">{item.day}</div>
                </div>
              )
            }
            )}
          </div>
          <hr />
          <div className="expense-footer">
            <div className="expense-footer-info">
              <div className="expense-footer-left">
                <div className="expense-footer-header">Total this month</div>
                <div className="expense-footer-value">$478.33</div>
              </div>
              <div className="expense-footer-right">
                <div className="expense-footer-month">+2.4%</div>
                <div className="expense-footer-month-text">from last month</div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default App;
